"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation_ai2Csv = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonOperationNode_1 = require("../../commonOperationNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const friendlyName = 'ai2Csv';
const commonProps = (0, commonOperationNode_1.commonZodOperationNodeUtils)(types_1.nodeType, types_1.UIConfigSchema, friendlyName);
// create a new UI node of this type.
const createNewNode = ({ id, nodeToCopy }) => {
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            operation: 'ai2Csv',
            prompt: 'Custom prompt for LLM to utilize.',
            documents: [
                {
                    artifactSlug: 'PLACEHOLDER',
                    configuration: {
                        fileExt: 'xlsx',
                        sheets: [
                            {
                                sheetName: 'Document Configuration is Optional, but should prefer to configure for XLSX/PDF inputs',
                                endRow: 100,
                            },
                        ],
                    },
                },
            ],
            // this is optional, but we should encourage adding configuration for xlsx + pdf type inputs
            // eventually fields may become optional and we can add template selection for commonly used csv schema like "financialStatements"
            fields: [{ field: 'PLACEHOLDER', type: 'string' }],
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(commonProps.isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, inputs, outputs, }) => {
    (0, common_1.finleyAssert)(commonProps.isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_rawLoanTape',
        'file_rawCashBalanceFeed',
        'file_rawRepaymentTape',
        'file_rawSupplementalTape',
        'file_rawReceivableDocumentation',
        'file_intermediateTape',
    ];
    const errors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        minInputs: 1,
        maxInputs: 100,
        minOutputs: 1,
        maxOutputs: 1,
    });
    const { configuration: { documents }, } = node;
    if (documents) {
        const possibleInputArtifactSlugs = new Set();
        inputs.forEach(({ node: inputNode, uiNode: inputUINode }) => {
            const inputFriendlyName = commonProps.getFriendlyName(inputNode);
            if (inputUINode.isOperation) {
                errors.push(`${friendlyName} cannot use ${inputFriendlyName} as input.`);
            }
            else {
                const inputArtifactSlug = inputUINode.getArtifactSlug(inputNode);
                possibleInputArtifactSlugs.add(inputArtifactSlug);
            }
        });
        documents.forEach(({ artifactSlug }) => {
            if (!possibleInputArtifactSlugs.has(artifactSlug)) {
                errors.push(`[artifactSlug:${artifactSlug}] does not exist as a valid input node.`);
            }
        });
    }
    return errors;
};
/**
 * Represents an opearation node
 */
exports.operation_ai2Csv = {
    ...commonProps,
    nodeType: types_1.nodeType,
    nodeTypeText: friendlyName,
    operationType: 'tapebuilder_postSanitize',
    createNewNode,
    hasValidConfig,
};
//# sourceMappingURL=uinode.js.map